import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Crown, X } from "lucide-react";
import { PermsButton } from "../permissions/PermsButton";
import { localName } from "../../lib/localName";

// صف مدير القسم — نفس أسلوب صف الموظف: نقر يفتح الملف + صلاحيات + إزالة.
export const DepartmentManagerRow = ({ manager, onRemove }) => {
  const { t, i18n } = useTranslation();
  const isAr = (i18n.language || "ar").startsWith("ar");
  if (!manager) return null;
  const display = localName(manager, manager.email);
  return (
    <div
      className="flex flex-wrap items-center gap-3 rounded-2xl border border-amber-400/40 bg-amber-500/5 px-3 py-2 shadow-neu-sm"
      data-testid={`dept-manager-row-${manager.id}`}
    >
      <Link
        to={`/employees/${manager.id}`}
        target="_blank"
        rel="noreferrer"
        className="flex min-w-0 flex-1 items-center gap-3"
        data-testid={`dept-manager-link-${manager.id}`}
      >
        <span className="grid h-8 w-8 place-items-center rounded-2xl bg-amber-500/15 text-amber-600 shadow-neu-in dark:text-amber-300">
          <Crown className="h-4 w-4" />
        </span>
        <span className="min-w-0 flex-1">
          <p className="truncate text-xs font-bold">
            {display}
            <span className="ms-2 rounded-lg bg-amber-500/20 px-2 py-0.5 text-[10px] font-bold text-amber-700 dark:text-amber-200">
              {t("departments.form.manager")}
            </span>
          </p>
          <p className="truncate text-[10px] text-muted-foreground">{manager.email}</p>
        </span>
      </Link>
      <PermsButton userId={manager.id} userName={display} small />
      <button
        type="button"
        onClick={onRemove}
        title={t("departments.form.unassignManager")}
        className="rounded-2xl p-2 text-destructive shadow-neu-sm hover:bg-destructive/10"
        data-testid="dept-manager-remove"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
